// Rastreamento Bella Film RJ
// GTM carrega imediatamente no primeiro carregamento, sem depender de consentimento ou localStorage.
// GTM carrega SOMENTE em produção (www.bellafilmrj.com / bellafilmrj.com), nunca em preview.
// GA4 (G-SBNM1Z7VXE) e Google Ads (AW-11330079923) estão configurados dentro do contêiner GTM.
// Cliques em wa.me / tel: / mailto: são detectados pelos gatilhos do GTM — sem pushes manuais para eles.

const GTM_ID = process.env.REACT_APP_GTM_ID;
const PROD_HOSTS = ["www.bellafilmrj.com", "bellafilmrj.com"];
let gtmLoaded = false;

export const isProdHost = () =>
  typeof window !== "undefined" && PROD_HOSTS.includes(window.location.hostname);

function push(data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

export function captureUtm() {
  try {
    if (sessionStorage.getItem("bf_utm")) return;
    const q = new URLSearchParams(window.location.search);
    const utm = {};
    ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => {
      const v = q.get(k);
      if (v) utm[k] = v;
    });
    sessionStorage.setItem("bf_utm", JSON.stringify(utm));
  } catch (e) {}
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem("bf_utm") || "{}");
  } catch (e) {
    return {};
  }
}

export function trackEvent(name, params = {}) {
  push({ event: name, ...params });
}

// Gatilhos do GTM já detectam links wa.me, tel: e mailto: — funções mantidas como no-op.
export const trackWhatsApp = () => {};
export const trackPhone = () => {};

export const trackServiceSelect = (service) => trackEvent("service_select", { service });
export const trackProductSelect = (product, category) => trackEvent("product_select", { product, category });
export const trackOrcamentoView = () => trackEvent("orcamento_view", {});

export function trackLead() {
  push({ event: "lead", form_name: "orcamento", lead_source: "site" });
}

let lastTrackedPath = typeof window !== "undefined" ? window.location.pathname : null;

export function trackRouteChange() {
  const path = window.location.pathname;
  if (path === lastTrackedPath) return;
  lastTrackedPath = path;
  push({
    event: "route_change",
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function injectAnalytics() {
  window.dataLayer = window.dataLayer || [];
  if (!GTM_ID || gtmLoaded || !isProdHost()) return;
  gtmLoaded = true;
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(s);
  const ns = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";
  ns.appendChild(iframe);
  document.body.insertBefore(ns, document.body.firstChild);
}
